import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=32d1edfa&scoped=true&"
import script from "./Footbar.vue?vue&type=script&lang=js&"
export * from "./Footbar.vue?vue&type=script&lang=js&"
import style0 from "./Footbar.vue?vue&type=style&index=0&id=32d1edfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1edfa",
  null
  
)

export default component.exports